import { Provider } from '@angular/core';
import { LayoutBase2PageViewContractId as Provide } from '@daas-consulting/production/shared/frontend/view_contracts';
import { LayoutBase2PageViewModel as Value } from '@daas-consulting/production/shared/frontend/view_models';

export const LayoutBase2PageViewModelProvider: Provider = {
  provide: Provide,
  useClass: Value,
};
